import { useEffect } from "react";
export function useHeaderBehindModal(isOn) {
  useEffect(() => {
    const header = document.querySelector(".topHeader");
    if (!header) return undefined;
    const prevZ = header.style.zIndex;
    if (isOn) header.style.zIndex = "0";
    return () => { header.style.zIndex = prevZ || ""; };
  }, [isOn]);
}